export default __webpack_public_path__ + "static/media/kakao.fb105919.png";